import * as React from 'react';
import { Fragment } from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import * as pages from './pages';
export var App = function () { return (React.createElement(Router, null,
    React.createElement(Fragment, null,
        React.createElement(Switch, null,
            React.createElement(Route, { path: ["/:slug", ""], exact: true, component: pages.SharePage }))))); };
